import { UnidadeGestoraService } from "./../../../modules/basico/unidade-gestora/unidade-gestora.service";
import { EntidadeService } from "./../../../modules/basico/entidade/entidade.service";
import { Entidade } from "./../../../modules/basico/entidade/entidade";
import { Component, OnInit } from "@angular/core";
import { LayoutCss } from "../../../modules/basico/layout-css/layout-css";
import { SharedService } from "../../../common/shared.service";
import { Router } from "@angular/router";
import { MessageService } from "../../message/message.service";

@Component({
  selector: "app-entidade",
  templateUrl: "./entidade.component.html",
  styleUrls: ["./entidade.component.css"],
})
export class EntidadeComponent implements OnInit {
  layout: LayoutCss;
  entidades: Entidade[] = [];

  constructor(
    private sharedService: SharedService,
    private service: EntidadeService,
    private router: Router,
    private unidadeService: UnidadeGestoraService,
    private messageService: MessageService
  ) {}

  ngOnInit() {
    this.layout = this.sharedService.layout;
    this.service.buscarTodas().subscribe((data) => (this.entidades = data));
  }

  setEntidade(entidade: Entidade) {
    // if (entidade.cnpj === "05309627000142") {
    //   if (!this.estaDentroDoIntervalo()) {
    //     setTimeout(() => {
    //       this.messageService.messageSuccess(
    //         "O horário de acesso ao sistema deverá ocorrer entre 8:00hs e 14:00hs!"
    //       );
    //       this.sharedService.logout();
    //       this.router.navigate(["/login"]);
    //     });
    //   }
    // }

    this.sharedService.entidade = entidade;
    this.unidadeService.buscarTodosPorEntidade(entidade).subscribe((data) => {
      this.sharedService.usuario.unidadesGetoras = data;
      this.sharedService.adm = false;
      this.router.navigate(["/"]);
    });
  }

  estaDentroDoIntervalo(): boolean {
    const horaAtual = new Date();
    const inicio = new Date(
      horaAtual.getFullYear(),
      horaAtual.getMonth(),
      horaAtual.getDate(),
      7,
      0,
      0
    ); // 7h
    const fim = new Date(
      horaAtual.getFullYear(),
      horaAtual.getMonth(),
      horaAtual.getDate(),
      14,
      0,
      0
    ); // 14h
    const horaValor = horaAtual.getTime();
    const inicioValor = inicio.getTime();
    const fimValor = fim.getTime();
    return horaValor >= inicioValor && horaValor <= fimValor;
  }
}
